import { render, staticRenderFns } from "./staticAll.vue?vue&type=template&id=1c6614d6&scoped=true&"
import script from "./staticAll.vue?vue&type=script&lang=js&"
export * from "./staticAll.vue?vue&type=script&lang=js&"
import style0 from "./staticAll.vue?vue&type=style&index=0&id=1c6614d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6614d6",
  null
  
)

export default component.exports